module.exports = __webpack_public_path__ + "img/logo-uaysen_blanco.9b0c356e.png";